import React, { useState } from 'react'
import { Box, makeStyles } from '@material-ui/core'
import InfographicNavigation from '../components/InfographicNavigation'
import SydButton from '../../../../commonDesign/Button'
import SydModal from '../../../../commonDesign/SydModal'
import InfographicBlocksTable from './components/InfographicBlocksTable'
import { CreateInfographicBlockForm } from './components/CreateInfographicBlockForm'

const useStyles = makeStyles(() => ({
  container: {
    padding: '1rem',
    display: 'flex',
    flex: '1',
    flexDirection: 'column'
  }
}))

const InfographicBlocksListView = () => {
  const classes = useStyles()
  const [showCreateModal, setShowCreateModal] = useState(false)

  return (
    <div className={classes.container}>
      <InfographicNavigation />
      <Box display='flex' justifyContent='flex-end'>
        <SydButton onClick={() => setShowCreateModal(true)} icon='add' variant='primary'>
          Create Infographic Block
        </SydButton>
      </Box>

      <Box mt={2}>
        <InfographicBlocksTable />
      </Box>

      <SydModal
        open={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        title='Create Infographic Template'
      >
        <Box>
          <CreateInfographicBlockForm onCancel={() => setShowCreateModal(false)} />
        </Box>
      </SydModal>
    </div>
  )
}

export default InfographicBlocksListView
